"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _generalStore = _interopRequireDefault(require("general-store"));

var _OnboardingRecord = _interopRequireDefault(require("./OnboardingRecord"));

var _OnboardingActionTypes = require("./OnboardingActionTypes");

var _immutable = require("immutable");

var _state = (0, _immutable.Map)();

var OnboardingStore = _generalStore.default.define().defineGet(function (name) {
  if (name) {
    return _state.get(name);
  }

  return _state;
}).defineResponseTo(_OnboardingActionTypes.REGISTER_ONBOARDING, function (_ref) {
  var name = _ref.name,
      _ref$updates = _ref.updates,
      updates = _ref$updates === void 0 ? (0, _immutable.Map)() : _ref$updates;

  if (_state.has(name)) {
    return _state.get(name);
  }

  _state = _state.set(name, (0, _OnboardingRecord.default)((0, _immutable.fromJS)({
    name: name,
    active: false
  }).merge(updates)));
  return _state;
}).defineResponseTo(_OnboardingActionTypes.START_ONBOARDING_TOUR, function (_ref2) {
  var name = _ref2.name,
      _ref2$onStep = _ref2.onStep,
      onStep = _ref2$onStep === void 0 ? 0 : _ref2$onStep;

  var activeTour = _state.get(name);

  if (!activeTour) {
    return _state;
  }

  activeTour = activeTour.merge({
    active: true,
    onStep: onStep
  });
  _state = _state.set(name, activeTour);
  return _state;
}).defineResponseTo(_OnboardingActionTypes.END_ONBOARDING_TOUR, function (name) {
  _state = _state.setIn([name, 'active'], false);
  return _state;
}).defineResponseTo(_OnboardingActionTypes.SET_ONBOARDING_TOUR_STEP, function (_ref3) {
  var name = _ref3.name,
      onStep = _ref3.onStep;

  var activeTour = _state.get(name);

  if (!activeTour) {
    return _state;
  }

  activeTour = activeTour.merge({
    onStep: onStep
  });
  _state = _state.set(name, activeTour);
  return _state;
}).register();

var _default = OnboardingStore;
exports.default = _default;
module.exports = exports.default;